import { render } from "./UserPaymentRegistration.vue?vue&type=template&id=9daa61c2&scoped=true"
import script from "./UserPaymentRegistration.vue?vue&type=script&lang=js"
export * from "./UserPaymentRegistration.vue?vue&type=script&lang=js"

import "./UserPaymentRegistration.vue?vue&type=style&index=0&id=9daa61c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9daa61c2"]])

export default __exports__